import { NavLink } from "react-router-dom";

function Footer() {
  return (
    <div className="fullFooter">
      <section className="socialMediaLinks">
        <a href="https://www.facebook.com/andybgardenservices">
          <i className="fab fa-facebook fa-2x"></i>
        </a>
        <a href="https://www.instagram.com/andybgardenservices/">
          <i className="fab fa-instagram fa-2x"></i>
        </a>
        <a href="https://twitter.com/andybgardens">
          <i className="fab fa-twitter fa-2x"></i>
        </a>
        <a href="https://api.whatsapp.com/send?phone=447799063905">
          <i className="fab fa-whatsapp fa-2x"></i>
        </a>
        <a href="http://m.me/andybgardenservices">
          <i className="fab fa-facebook-messenger fa-2x"></i>
        </a>
      </section>
      <footer className="PolicyContainer">
        <span className="copyrightText">©2021 Andy B Garden Services.</span>
        <NavLink to="/privacy">Privacy Policy</NavLink>
      </footer>
    </div>
  );
}

export default Footer;
